import { query } from 'src/utils/request';
import { stringify } from 'qs';

// 费用类型
export const getOuterUserList = (data) => {
  return query('/zlb/api/expense/outer-user/query-list', { method: 'POST', data });
};

// 获取常用出行人
export const getTravelerList = () => {
  return query('/zlb/api/travel/accompany/get');
};

// 查看外部人员详情
export const getOuterUserInfo = (params) => {
  return query(`/zlb/api/expense/outer-user/query-info?${stringify(params)}`);
};

// 银行列表
export async function getBankList (params) {
  return query(`/zlb/api/pay/bankCard/bank/list?${stringify(params)}`);
}

// 增加外部人员
export async function addOuterUser (data) {
  return query('/zlb/api/expense/outer-user/add', { method: 'POST', data });
}

// 删除外部人员
export async function deleteOuterUser (data) {
  return query('/zlb/api/expense/outer-user/delete', { method: 'POST', data });
}

// 获取常用出行人详情
export async function getTravelInfo (params) {
  return query(`/zlb/api/travel/accompany/detail?${stringify(params)}`);
}
